import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useFeatureToggles, useDispatch } from '@grandvisionhq/state';
import { init } from '../actions.js';
import AuthContext from '../AuthContext/AuthContext.js';

class Provider extends React.PureComponent {
    componentDidMount() {
        if (this.props.enabled) {
            this.props.init(this.props.settings);
        }
    }
    render() {
        const { enabled , children  } = this.props;
        const value = {
            enabled
        };
        return /*#__PURE__*/ React.createElement(AuthContext.Provider, {
            value: value
        }, children);
    }
}
const AuthProvider = (props)=>{
    const { isMyAccountEnabled  } = useFeatureToggles();
    const dispatch = useDispatch();
    const initWrapper = React.useCallback((settings)=>{
        dispatch(init(settings));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement(Provider, swcHelpers.extends({}, props, {
        enabled: isMyAccountEnabled,
        init: initWrapper
    }));
};
var AuthProvider$1 = AuthProvider;

export { AuthProvider, AuthProvider$1 as default };
//# sourceMappingURL=AuthProvider.js.map
